import React, {useContext, useEffect, useState} from "react";
import db from "../../../services/query";
import InfoHeader from "./InfoHeader";
import PersonalInfo from "./PersonalInfo";
import MainTitle from "../../common/MainTitle";
import MainButton from "../../common/MainButton";
import lbl from "../../../data/Labels.json";
import EducationalInfo from "./EducationalInfo";
import ClassInfo from "./ClassInfo";
import DocumentsInfo from "./DocumentsInfo";

const InfoProfile = (props) => {

    const {sid} = props.match.params;
    const [student, setStudent] = useState({});
    const [info, setInfo] = useState({});

    useEffect(async () => {
        const ac = new AbortController();
        requestData();
        return () => ac.abort();
    }, []);

    const requestData = async () => {
        let query = `students/${sid}`;
        let infoQuery = `${query}/info`;

        await db.getAll(query).then(({data}) => {
            // Sorting by entry year and getting the latest semester info
            const student = data.data.sort(
                (a, b) => a.semester_entry_year_id < b.semester_entry_year_id
            )[0] ?? {};
            setStudent(student);
        });

        await db.getAll(infoQuery).then(({data}) => {
            const info = data.data[0];
            setInfo(info);
        });
    };

    return (
        <React.Fragment>
            <InfoHeader student={student} callback={requestData}/>
            <PersonalInfo student={student} studentInfo={info} callback={requestData}/>
            <EducationalInfo student={student}  studentInfo={info} callback={requestData}/>
            <ClassInfo student={student}  studentInfo={info} callback={requestData}/>
            <DocumentsInfo student={student}  studentInfo={info} callback={requestData}/>
        </React.Fragment>
    );
};

export default InfoProfile;
